import { render, staticRenderFns } from "./IconAddPerson.vue?vue&type=template&id=700ec400&"
import script from "./IconAddPerson.vue?vue&type=script&lang=js&"
export * from "./IconAddPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('700ec400')) {
      api.createRecord('700ec400', component.options)
    } else {
      api.reload('700ec400', component.options)
    }
    module.hot.accept("./IconAddPerson.vue?vue&type=template&id=700ec400&", function () {
      api.rerender('700ec400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconAddPerson.vue"
export default component.exports